import React from 'react';
import styled, { css, type RuleSet } from 'styled-components';
import { breakpoint, colors, sizes } from 'variables';
import type { IResponsiveImageModel } from 'shared/interfaces/responsiveImage';
import PictureDeprecated from 'components/generic/picture/PictureDeprecated';

const ImageWrapper = styled.div`
    display: flex;
    justify-content: center;
`;

const ImageContainer = styled.div<{ width?: string }>`
    max-width: 100%;
    margin: 0 auto;
    flex: 0 0 auto;
    border-radius: 50%;
    border: 5px solid ${colors.myProfileBackground};
    overflow: hidden;

    ${({ width }): RuleSet =>
        width
            ? css`
                  width: ${width};
              `
            : css`
                  width: 100px;

                  ${breakpoint.up(sizes.md)} {
                      width: 125px;
                  }
              `};

    img {
        aspect-ratio: 1/1;
        object-fit: cover;
        width: 100%;

        /* added support for Safari 14 and down */
        @supports not (aspect-ratio: 1/1) {
            height: 100px;

            ${breakpoint.up(sizes.md)} {
                height: 125px;
            }
        }
    }
`;

interface IAdvisorImageProps {
    image: IResponsiveImageModel;
    width?: string;
}

export const AdvisorImage = (props: IAdvisorImageProps): JSX.Element => {
    const { image, width, ...rest } = props;
    return (
        <ImageWrapper {...rest}>
            <ImageContainer width={width}>
                <PictureDeprecated {...image} />
            </ImageContainer>
        </ImageWrapper>
    );
};

export default AdvisorImage;
